import { render, staticRenderFns } from "./NovoVinculo.vue?vue&type=template&id=0e990e80"
import script from "./NovoVinculo.vue?vue&type=script&lang=js"
export * from "./NovoVinculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports